import {
	BACKLOG_ACCORDION_NUDGE_ID,
	BOARD_CREATE_COLUMN_NUDGE_ID,
} from '@atlassian/jira-onboarding-core/src/constants.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import {
	KEY_OPEN_TASK,
	SCRUM_ONBOARDING_TASK,
	KANBAN_ONBOARDING_TASK,
	ADD_COLUMNS_TASK,
} from '../../../common/constants.tsx';
import { pushToBackend } from '../../../common/utils/push-to-backend.tsx';
import type { State } from '../../model/types.tsx';
import { setNudgeStep } from '../nudge-step/index.tsx';
import { setHasNudgeActive } from '../set-has-nudge-active/index.tsx';

const openTask =
	(taskId: string): Action<State> =>
	({ setState }) => {
		setState({ openTask: taskId });

		pushToBackend({
			key: KEY_OPEN_TASK,
			value: taskId,
		});
	};

type NextOpenTaskOptions = {
	closeNudge?: boolean;
};
export const nextOpenTask =
	(taskId: string, { closeNudge }: NextOpenTaskOptions = {}): Action<State> =>
	({ dispatch, getState }) => {
		dispatch(openTask(taskId));
		const { completedTaskList } = getState();

		const taskIsCompleted = completedTaskList.includes(taskId);
		const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;

		if (closeNudge) {
			dispatch(setHasNudgeActive(false, taskId));
		} else {
			dispatch(setHasNudgeActive(taskIdExistsAndIsNotCompleted, taskId));
		}

		// This is a temporary solution for Scrum Onboarding.
		// See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
		if (taskIdExistsAndIsNotCompleted && taskId === SCRUM_ONBOARDING_TASK) {
			dispatch(setNudgeStep(BACKLOG_ACCORDION_NUDGE_ID));
			// @todo: Cleanup for simplify kanban QS productionisation
		} else if (taskIdExistsAndIsNotCompleted && taskId === KANBAN_ONBOARDING_TASK) {
			dispatch(setNudgeStep(BOARD_CREATE_COLUMN_NUDGE_ID));
		} else if (taskIdExistsAndIsNotCompleted && taskId === ADD_COLUMNS_TASK) {
			dispatch(setNudgeStep(BOARD_CREATE_COLUMN_NUDGE_ID));
		} else {
			dispatch(setNudgeStep(''));
		}
	};

export const nextAutoOpenTask =
	(taskId: string): Action<State> =>
	({ dispatch }) => {
		dispatch(openTask(taskId));
		dispatch(setHasNudgeActive(false, taskId));
		dispatch(setNudgeStep(''));
	};
